<template>
  <div
    class="base-promotion"
    role="region"
    :class="[
      `base-promotion-${variant}`,
      {
        dismissable: dismissable,
        fullClickable: fullClickable,
      },
    ]"
    :aria-label="ariaLabel"
    :style="{ zIndex: zIndex }"
  >
    <div
      v-if="fullClickable"
      tabindex="0"
      v-aha-emit-action
      :name="`promo-${promotionName}-wrapper`"
      class="base-promotion__content-container-wrapper"
      @click="$emit('actions-link-click')"
      @keydown.enter="$emit('actions-link-click')"
      @keydown.space="$emit('actions-link-click')"
    ></div>
    <div class="base-promotion__content-container">
      <slot name="icon" />
      <div class="base-promotion__content">
        <slot name="content">
          <span class="base-promotion__content-text">
            {{ content }}
          </span>
        </slot>
      </div>
      <div class="base-promotion__actions">
        <slot name="actions">
          <aha-antd-button
            v-aha-emit-action
            :name="`promo-${promotionName}-btn`"
            variant="link"
            size="sm"
            class="base-promotion__actions-link font-semibold z-2"
            :aria-label="actionsLinkAriaLabel"
            :disabled="actionDisabled"
            :submitting="actionLoading"
            is-loading-inline
            @click.stop.prevent="$emit('actions-link-click')"
          >
            {{ actionsLinkText }}
          </aha-antd-button>
        </slot>
      </div>
    </div>
    <slot name="close">
      <aha-icon-button
        v-if="isClosable"
        v-aha-emit-action
        :name="`promo-${promotionName}-close`"
        class="base-promotion__close z-2"
        :aria-label="closeAriaLabel"
        @click.stop.prevent="$emit('close')"
      >
        <aha-icon
          name="aha-x"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        />
      </aha-icon-button>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'BasePromotion',
  props: {
    variant: {
      type: String,
      default: 'default',
    },
    promotionName: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    dismissable: {
      type: Boolean,
      default: true,
    },
    zIndex: {
      type: Number,
      default: 1,
    },
    closeAriaLabel: {
      type: String,
      default: '',
    },
    actionsLinkText: {
      type: String,
      default: '',
    },
    actionsLinkAriaLabel: {
      type: String,
      default: '',
    },
    fullClickable: {
      type: Boolean,
      default: false,
    },
    actionDisabled: {
      type: Boolean,
      default: false,
    },
    actionLoading: {
      type: Boolean,
      default: false,
    },
    isClosable: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.$emit('loaded')
  },
  methods: {
    emitBannerClick(event) {
      event.preventDefault()
      this.$emit('actions-link-click')
    },
  },
}
</script>

<style lang="scss" scoped>
.base-promotion {
  @apply relative;
  @apply flex items-center justify-center;
  @apply px-4 py-3;
  @apply bg-primary-20;
  @apply text-gray-100 font-semibold;

  &.dismissable {
    @apply pr-12;
  }

  &.fullClickable {
    @apply cursor-pointer;
    transition: box-shadow 0.2s ease-in-out;

    // &:hover {
    //   box-shadow: 0px 4px 4px rgba(0, 61, 132, 0.18);
    // }
  }
}

.base-promotion__close {
  @apply absolute right-4 top-1/2 transform -translate-y-1/2;
}

.base-promotion__content-container {
  @apply flex items-center justify-center;
  @apply w-full;
}

.base-promotion__content-container-wrapper {
  @apply w-full absolute z-0 inset-0 cursor-pointer;
}

.base-promotion-default {
  @apply bg-primary-20;
  @apply text-gray-100;
}

.base-promotion-primary {
  @apply bg-primary-20;

  @media screen and (min-width: 1280px) {
    background-image: url("../../../assets/images/background/symbol_logo_2.png"),
      url("../../../assets/images/background/symbol_logo_1.png");
    background-position: top right 8%, bottom left 8%;
    background-repeat: no-repeat;
    background-size: contain;
  }
}
</style>
